var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._b({attrs:{"cols":"12"}},'v-col',_vm.containerOptions,false),[_c('h2',{class:_vm.classes,attrs:{"id":_vm.$attrs.id}},[_c('b',{class:_vm.colors.text},[_vm._v(_vm._s(_vm.chapter))]),_vm._v("\n    "+_vm._s(_vm.$attrs.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }